import { PrismicLink } from '../../../prismic-link/PrismicLink';
import Button from '../../../components/Button';
import ResponsiveImage from '../../../components/ResponsiveImage';
import { RichText } from 'prismic-reactjs';
import {
  IPrismicImage,
  IPrismicLink,
  IPrismicRichText,
  PrismicLinkContext,
} from '@monofront/types';
import React from 'react';

export interface IResultDisplayProps {
  image: IPrismicImage;
  value: string;
  resultLegend?: string;
  numberLegend: IPrismicRichText;
  description: IPrismicRichText;
  ctaLabel: string;
  ctaLink: IPrismicLink;
  ctaText: string;
  context: PrismicLinkContext;
}

const ResultDisplay: React.FC<IResultDisplayProps> = ({
  image,
  value,
  resultLegend = '',
  numberLegend,
  description,
  ctaLabel,
  ctaLink,
  ctaText,
  context = PrismicLinkContext.SHOP,
}) => {
  const formatLegend = (type: string, _element: any, text: string) => {
    return type === 'span' ? text.replace('%LEGEND%', resultLegend) : null;
  };

  return (
    <>
      <div className="container">
        <div className="savings">
          <div className="savings-amount">
            <RichText render={numberLegend} htmlSerializer={formatLegend} />
            <div className="savings-text">
              <div className="illu-text">
                <ResponsiveImage
                  src="/images/text-mvnt.svg"
                  height={45}
                  width={25}
                />
              </div>
              <span className="amount">{value}</span>
              <div className="illu-text">
                <ResponsiveImage
                  src="/images/heart-text.svg"
                  height={45}
                  width={25}
                />
              </div>
            </div>
          </div>
          <div className="img">
            <ResponsiveImage
              src={image.url}
              alt={image.alt}
              height={150}
              width={150}
              objectFit="contain"
            />
          </div>
        </div>

        <div className="savings-legend">
          <RichText render={description} htmlSerializer={formatLegend} />
        </div>

        <div className="cta">
          <PrismicLink context={context} link={ctaLink}>
            <Button>{ctaLabel}</Button>
          </PrismicLink>
          {ctaText && (
            <div className="cta-text">
              <p>{ctaText}</p>
            </div>
          )}
        </div>
      </div>
      <style jsx>{`
        .container {
          display: flex;
          align-items: center;
          flex-direction: column;
        }

        .savings {
          display: flex;
          align-items: end;
          margin-bottom: var(--space-4);
        }

        .savings-amount {
          display: flex;
          flex-direction: column;
          max-width: 210px;
        }

        .amount {
          font-family: var(--font-family-1);
          font-size: var(--font-size-6);
          margin: 0 var(--space-2);
        }

        .savings-text {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: var(--space-3);
        }

        .savings-legend {
          max-width: 360px;
        }

        .illu-text {
          width: 20px;
        }

        .img {
          max-width: 120px;
        }

        .cta {
          margin-top: var(--space-4);
        }

        .cta-text > :global(*) {
          margin-top: var(--space-1);
          font-size: var(--font-size-1);
        }
      `}</style>
    </>
  );
};

export default ResultDisplay;
